import { render, staticRenderFns } from "./PortalApoioCadastro.vue?vue&type=template&id=659cfab4&"
import script from "./PortalApoioCadastro.vue?vue&type=script&lang=js&"
export * from "./PortalApoioCadastro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports